/**
 * @file main.component.spec.ts
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LABELS } from '@root/assets/doc/labels';
import { MailOrderAccessGuard } from '@core/guards';
import { MainComponent } from './main.component';
import { MailOrderPatientEnrollmentFormComponent } from '@shared/components';

const routes: Routes = [
  {
    path: '', component: MainComponent, children:
      [
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        {
          path: 'home', title: LABELS.LABEL_BOTTOM_TABS_HOME,
          loadChildren: () => import('./home/home.module').then((m) => m.HomeModule)
        },
        {
          path: 'orders',
          loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
          canActivate: [MailOrderAccessGuard]
        },
        {
          path: 'claims', title: LABELS.LABEL_BOTTOM_TABS_PHARMACY_CLAIMS,
          loadChildren: () => import('./claims/claims.module').then((m) => m.ClaimsModule)
        },
        {
          path: 'prescriptions', title: LABELS.LABEL_BOTTOM_TABS_PRESCRIPTIONS,
          loadChildren: () => import('./prescriptions/prescriptions.module').then((m) => m.PrescriptionsModule),
          canActivate: [MailOrderAccessGuard],
        },
        {
          path: 'drug', title: LABELS.LABEL_BOTTOM_TABS_DRUG_SEARCH,
          loadChildren: () => import('./drug/drug.module').then((m) => m.DrugModule)
        },
        {
          path: 'benefits', title: LABELS.LABEL_BOTTOM_TABS_PHARMACY_BENEFITS,
          loadChildren: () => import('./benefits/benefits.module').then((m) => m.BenefitsModule)
        },
        {
          path: 'find-pharmacy', title: LABELS.LABEL_BOTTOM_TABS_PHARMACY_SEARCH,
          loadChildren: () => import('./find-pharmacy/find-pharmacy.module').then((m) => m.FindPharmacyModule)
        },
        {
          path: 'help',
          loadChildren: () => import('./help/help.module').then((m) => m.HelpModule)
        },
        {
          path: 'membership', title: LABELS.LABEL_BOTTOM_TABS_PHARMACY_MEMBERSHIP,
          loadChildren: () => import('./membership/membership.module').then((m) => m.MembershipModule)
        },
        { path: 'settings', loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule) },
        {
          path: 'cart', title: LABELS.LABEL_CART_HOME_CART_ITEMS,
          loadChildren: () => import('./cart/cart.module').then((m) => m.CartModule),
          canActivate: [MailOrderAccessGuard]
        },
        {
          path: 'forms', title: LABELS.LABEL_FORMS,
          loadChildren: () => import('./custom-forms/custom-forms.module').then((m) => m.CustomFormsModule)
        },
        {
          path: 'clinical-reviews', title: LABELS.LABEL_MORE_CLINICAL_REVIEW,
          loadComponent: () => import('./clinical-reviews/clinical-reviews.component').then((m) => m.ClinicalReviewsComponent)
        },
        {
          path: 'pmart-patient-enrollment', title: LABELS.LABEL_PMART_ENROLLMENT_FORM_TITLE,
          component: MailOrderPatientEnrollmentFormComponent
        }
      ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
